import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { CircleBox } from "./CircleBox.js";
const useStyles = makeStyles()((theme) => ({
  circleBoxContainer: {
    display: "flex",
    alignItems: "center"
  },
  circleBoxText: {
    marginLeft: theme.spacing(1.5)
  }
}));
function CircleBoxWithText({ text, textBold, letter, ...circleProps }) {
  const { classes: styles } = useStyles();
  const variant = textBold ? "h4" : "body1";
  return /* @__PURE__ */ React.createElement(Box, { className: styles.circleBoxContainer }, letter ? /* @__PURE__ */ React.createElement(CircleBox, { ...circleProps, letter }) : null, /* @__PURE__ */ React.createElement(Box, { className: styles.circleBoxText }, /* @__PURE__ */ React.createElement(Typography, { variant }, text)));
}
export {
  CircleBoxWithText
};
//# sourceMappingURL=CircleBoxWithText.js.map
